import type { ModeColor } from "@src/types/factory-dashboard";

const GREY: ModeColor = {
  outline: "rgb(138, 143, 152)",
  background: "rgba(138, 143, 152, 0.1)",
};
const YELLOW: ModeColor = {
  outline: "rgb(225, 199, 67)",
  background: "rgba(225, 199, 67, 0.1)",
};
const GREEN: ModeColor = {
  outline: "rgb(25, 175, 0)",
  background: "rgba(25, 175, 0, 0.1)",
};

export const modeMapping = {
  0: { label: "modules.machineOverviewContainer.mode.off", color: GREY },
  1: { label: "modules.machineOverviewContainer.mode.setup", color: YELLOW },
  2: {
    label: "modules.machineOverviewContainer.mode.semiAutomatic",
    color: GREEN,
  },
  3: {
    label: "modules.machineOverviewContainer.mode.automatic",
    color: GREEN,
  },
};

export const machinesImex = [
  {
    sourceId: "691692df-13da-83da-99f5-a56d44249e02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "c265a908-e10e-810e-a0f5-76296c5fd302",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "b11420f1-e168-8168-817e-a6130e39f902",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "2406efdb-d000-8000-9989-94cf2b2bc602",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "a0303432-8eb0-8eb0-bc2d-7fe0b556b802",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "2b126fca-02f0-82f0-904f-a90f39477b02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "4d001adf-7c75-8c75-9abe-dfb370144b02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
  {
    sourceId: "db8c0ed5-aeb1-8eb1-9d5c-4b676240bf02",
    nodes: {
      opMode: "ns=4;s=APPL.system.sv_OperationMode",
      actCyclesDone: "ns=4;s=APPL.system.sv_iProdCounterAct",
      setCyclesCompleteToDo: "ns=4;s=APPL.system.sv_iProdCounterSet",
      productionDatasetName:
        "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sProductionDatasetName",
      customer: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.sJobCustomer",
      material: "ns=4;s=APPL.TIG.sv_TIG.job.jobData.yMaterial[1]",
    },
    modeMapping,
  },
];
